import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { Toaster } from 'react-hot-toast';
import { registerSW } from 'virtual:pwa-register';
import { initSentry } from './lib/sentry';
import { logger } from './lib/logger';
import App from './App';
import './styles/globals.css';
import 'highlight.js/styles/github-dark.css';
import './i18n';

initSentry();

// Register the service worker with an explicit error handler so that any
// rejection (network errors, HTTPS mismatches, quota exceeded, etc.) is
// caught and logged rather than surfacing as an unhandled promise rejection
// in Sentry (issue #820). In autoUpdate mode (registerType: 'autoUpdate' in
// vite.config.ts), the SW calls self.skipWaiting() in its own install handler
// and registerSW reloads the page on the 'activated' event — no manual
// SKIP_WAITING message is needed from the client side.
registerSW({
  onRegisterError(err) {
    // Use logger.error (always active, even in production) so registration
    // failures remain visible in Sentry rather than being silently swallowed.
    logger.error('ServiceWorker registration failed:', err);
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: 'var(--bg-elevated)',
            color: 'var(--text-primary)',
            border: '1px solid var(--border-default)',
          },
          success: {
            iconTheme: {
              primary: 'var(--profit)',
              secondary: 'white',
            },
          },
          error: {
            iconTheme: {
              primary: 'var(--loss)',
              secondary: 'white',
            },
          },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>
);
